import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ColumnNames,
  ColumnTypes,
  DataLeadCard,
  DataLeadPerState,
  Lead,
  LeadsBySearch,
  LeadsPaginationResult,
} from '@interfaces';
import { OrderService } from '@services';
import { TrackLeadDialogComponent } from '../dialogs/track-lead-dialog/track-lead-dialog.component';

@Component({
  selector: 'unicon-lead-search',
  templateUrl: './lead-search.component.html',
  styleUrl: './lead-search.component.scss',
})
export class LeadSearchComponent {
  @Input() listCard?: LeadsPaginationResult;
  protected value?: string | number = '';
  protected valueSearch?: string | number = '';
  protected showSearch: boolean = false;
  protected isLoading: boolean = false;
  protected leads: LeadsBySearch[] = [];
  protected columnNames: ColumnNames = {
    [ColumnTypes.ASSIGNED]: 'assigned',
    [ColumnTypes.PROCESSING]: 'processing',
    [ColumnTypes.QUOTED]: 'quoted',
    [ColumnTypes.SCHEDULED]: 'scheduled',
    [ColumnTypes.PAID]: 'paid',
    [ColumnTypes.AFTERSALE]: 'afterSale',
  };

  constructor(
    private dialog: MatDialog,
    private orderService: OrderService,
  ) {}
  protected onSearch(event: Event) {
    this.isLoading = true;
    const target = event.target as HTMLInputElement;
    this.valueSearch = target?.value;
    if (
      this.valueSearch !== '' &&
      this.valueSearch !== undefined &&
      this.valueSearch.length > 2
    ) {
      this.orderService.getLeadsBySearch(this.valueSearch).subscribe({
        next: (leads: LeadsBySearch[]) => {
          this.isLoading = false;
          this.leads = leads;
        },
        error: () => {
          this.isLoading = false;
        },
      });
    }
  }

  protected onShowSearch() {
    this.showSearch = !this.showSearch;
  }

  public onClose() {
    this.showSearch = !this.showSearch;
    this.valueSearch = '';
    this.leads = [];
  }

  public getColumn(lead: LeadsBySearch) {
    const columnName = lead.orderStatusName as ColumnTypes;
    const type = this.columnNames[columnName] as keyof LeadsPaginationResult;

    return type;
  }

  protected getOderChat(listCard: DataLeadCard[], order: Lead) {
    this.onClose();
    this.dialog.open(TrackLeadDialogComponent, {
      data: { listCard: listCard, lead: order },
      disableClose: false,
      autoFocus: false,
      width: 'auto',
      height: 'auto',
      panelClass: 'track-lead-dialog',
    });
  }

  protected onShowChatLead(lead: LeadsBySearch) {
    const typeName = this.getColumn(lead);
    if (this.listCard && typeName && typeName in this.listCard) {
      const column = this.listCard[
        typeName as keyof LeadsPaginationResult
      ] as DataLeadPerState;

      this.orderService.getOrder(lead.orderId).subscribe({
        next: (lead: Lead) => {
          const newLead = { ...lead, orderId: lead.id };
          this.getOderChat(column.items, newLead);
        },
        error: () => {
          this.onClose();
        },
      });
    }
  }
}
